<template>
  <button class="checkbox" type="button" :checked="checked" @click="toggle">
    <i class="fas fa-check"></i>
  </button>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value() {
      this.checked = this.value
    }
  },
  methods: {
    toggle() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    }
  },
  mounted: function() {
    this.checked = this.value
  }
}
</script>

<style scoped>
.checkbox {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, .5);
  color: #030303;
  width: 16px;
  height: 16px;
  background: none;
  border-radius: 0;
  padding: 0;
}

.checkbox[checked] {
  background: #ffd675;
  border-color: #ffd675;
}

.checkbox i {
  opacity: 0;
  font-size: 9px;
}

.checkbox[checked] i {
  opacity: 1;
}
</style>
